<template>
  <div>
    <div class="row">
      <h3 class="card-title" style="text-decoration:underline;">
        Αρχεία
      </h3>
    </div>
    <div class="col-12">
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>Α/Α</th>
              <th>Δημιουργήθηκε</th>
              <th>Αρχείο</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(file, index) in fileList" :key="file.name">
              <td>{{ index + 1 }}</td>
              <td>{{ file.created_at }}</td>
              <td>
                <a :href="dummyPdf" target="_blank">{{ file.name }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-4 mt-5">
      <div class="mt-3">
        <label>Εισαγωγή Εγγράφων</label>
        <input type="file" class="form-control" multiple @change="previewFiles" ref="myFiles" />
      </div>
      <div class="col-6 mt-4">
        <button class="btn btn-primary" v-if="buttonBrowseFileShow" @click.prevent="submitFiles">
          Αποθήκευση
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      dummyPdf: process.env.BASE_URL + "dummy.pdf",
      buttonBrowseFileShow: false,
      fileList: [
        {
          created_at: moment(
            new Date(+new Date() - Math.floor(Math.random() * 10000000000))
          ).format("DD/MM/YYYY"),
          name: "Προσωπικά Στοχεία.pdf",
          file: this.dummyPdf,
        },
      ],
    };
  },
  methods: {
    previewFiles() {
      const myFiles = this.$refs.myFiles.files;
      if (myFiles.length > 0) {
        this.buttonBrowseFileShow = true;
      }
    },
    submitFiles() {
      Swal.fire({
        title: "Τα αρχεία καταχωρήθηκαν με επιτυχία!",

        icon: "success",
      });
    },
  },
};
</script>
